import {injectableClass} from '../utils/Utils'
import {BaseTrade, CMD} from './BaseTrade'
import moment from 'moment-timezone'


@injectableClass("webtrader")
export class TradeOption extends BaseTrade {
  get isOpen() {
    return !this.close_time
  }

  get pointsDifference() {
    if (!this.quote)
      return
    let mult = this.isSell ? -1 : 1
    return (mult * (this.quote.bid - this.open_price) * this.quote.power).toFixed(0)
  }

  update(data) {
    this._update(data)
    if (this.isOpen && !data.options_data && !this.optionsDataIsLoading) {
      data.optionsDataIsLoading = true
      this.loadData().then((res) => {
        this._update(res.data)
      }).finally(() => data.optionsDataIsLoading = false)
    }
  }
  _update(data) {
    if (data.options_data) {
      data.options_data.expiration_time = moment(data.options_data.expiration_time)
    }
    super.update(data)


    if (this.options_data && this.close_time && (this.options_data.expiration_time.unix() - moment(this.close_time).unix() > 10)) {
        this.options_data.expiration_time = moment(data.close_time);
    }
  }

  get isWinning() {
    /* I don't really know why we can't just check for pointsDifference of some such, this is backported code */
    if (!this.options_data)
      return undefined

    if (this.options_data.option_type == 1) {
      if (this.cmd == CMD.BUY && this.open_price < this.quote.bid) {
        return true
      } else if (this.cmd == CMD.SELL && this.open_price > this.quote.bid) {
        return true
      }
    } else if (this.options_data.option_type == 2) {
      if (this.cmd == CMD.BUY_LIMIT && this.open_price < this.quote.bid) {
        return true
      } else if (this.cmd == CMD.SELL_LIMIT && this.open_price > this.quote.bid) {
        return true
      } else if (this.options_data.option_type == 3 && [CMD.BUY, CMD.SELL].includes(this.cmd) && this.tp < this.quote.bid) {
        return true
      }
    }
    return false
  }

  recalculateProfit() {
    //wait for options data loaded
    if (!this.options_data)
      return

    let profit = 0
    if (this.constructor.Account.info.group.options_style !== "european" && this.isWinning) {
      let tz = ""
      if (moment().tz('Europe/Berlin').isDST()) {
        tz = "Europe/Moscow"
      } else {
        tz = "Europe/Kaliningrad"
      }
      let howLongAgo = moment().diff(moment.tz(this.open_time, tz), 's')
      let timeLeft = this.options_data.expiration_time.diff(this.open_time, 's')
      profit = howLongAgo / timeLeft * this.options_data.early_pay - this.options_data.early_commission
    } else {
      if (this.options_data.option_type == 1) {
        if (this.cmd == CMD.BUY) {
          if (this.open_price < this.quote.bid)
            profit = this.options_data.win_pay
          else if (this.open_price > this.quote.bid)
            profit = this.options_data.loss_pay
          else
            profit = this.options_data.nill_pay
        } else if (this.cmd == CMD.SELL) {
          if (this.open_price < this.quote.bid)
            profit = this.options_data.loss_pay
          else if (this.open_price > this.quote.bid)
            profit = this.options_data.win_pay
          else
            profit = this.options_data.nill_pay
        }
      } else if (this.options_data.option_type == 2) {
        if (this.cmd == CMD.BUY_STOP) {
          if (this.open_price < this.quote.bid)
            profit = this.options_data.win_pay
          else if (this.open_price > this.quote.bid)
            profit = this.options_data.loss_pay
          else
            profit = this.options_data.nill_pay
        } else if (this.cmd == CMD.SELL_STOP) {
          if (this.open_price < this.quote.bid)
            profit = this.options_data.loss_pay
          else if (this.open_price > this.quote.bid)
            profit = this.options_data.win_pay
          else
            profit = this.options_data.nill_pay
        }
      } else if (this.options_data.option_type == 3) {
        if ([CMD.BUY_LIMIT, CMD.SELL_LIMIT].includes(this.cmd)) {
          profit = this.options_data.loss_pay
        } else if ([CMD.BUY, CMD.SELL].includes(this.cmd)) {
          if (this.tp < this.quote.bid)
            profit = this.options_data.win_pay
          else if (this.tp > this.quote.bid)
            profit = this.options_data.loss_pay
          else
            profit = this.options_data.nill_pay
        }
      }
    }
    this.profit = profit * this.volume / 100 / 100
  }
}